import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

document.addEventListener(
    'wheel',
    (event) => {
        const el = document.activeElement;
        if (el instanceof HTMLInputElement && el.type === 'number') {
            event.preventDefault();
            el.blur();
        }
    },
    { passive: false },
);
